/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-04-21 11:33:22
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-04-30 14:38:32
 */

export default {
  path: 'trade_recharge',
  component: () => import(/* webpackChunkName: "sys_log-list" */ '@/pages/trade/RechargeList'),
  meta: {title:'充值流水'}
}
